import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useProjectContributors = (projectId) => {
  const fetchContext = useContext(FetchContext);
  return useQuery(
    ["project", projectId.toString(), "contributors"],
    async () => {
      const { data } = await fetchContext.authAxios.get(
        `/projects/${projectId}/contributors`
      );
      return data;
    }
  );
};
